module.exports = __webpack_public_path__ + "img/logo.b764a496.png";